<template>
  <ag-grid-vue
    v-bind="agEmployees"
    ref="agEmployees"
    style="height: 65vh;"
    class="ag-theme-alpine"
    @cellEditRequest="onCellEditRequest"
  />
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { getFirestore, collection, query, orderBy, getDocs, doc, setDoc } from "firebase/firestore";
import { AgGridVue } from "ag-grid-vue";
import BaseLoader from "@/components/BaseLoader.vue";
import EmptySection from "@/components/EmptySection.vue";
import AgBadge from "@/components/AgGrid/AgBadge.vue";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import cedis from "@/data/cedis.json";
import departments from "@/data/departments.json";

  export default {
    name: 'TableEmployees',
    components: {
      AgGridVue,
      BaseLoader,
      EmptySection,
      AgBadge,
    },
    data() {
      return {
        workShifts: null,
        agEmployees: {
          rowData: null,
          columnDefs: [
            {
              headerName: "ID Empleado",
              field: "id",
              filter: "agTextColumnFilter",
            },
            {
              headerName: "Nombre",
              field: "name",
              filter: "agTextColumnFilter",
              width: 500,
              editable: true,
              cellEditor: 'agTextCellEditor',
              tooltipValueGetter: () => 'Doble click para editar',
            },
            {
              headerName: "Departamento",
              field: "departamento",
              width: 300,
              filter: "agSetColumnFilter",
              filterParams: {
                values: departments.map((x) => x.name),
                defaultToNothingSelected: true,
              },
              editable: true,
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: departments.map((x) => x.name),
              },
              tooltipValueGetter: () => 'Doble click para editar',
            },
            {
              headerName: "CEDIS",
              field: "cedis",
              filter: "agSetColumnFilter",
              filterParams: {
                values: cedis.map((x) => x.id),
                defaultToNothingSelected: true,
              },
              tooltipValueGetter: () => 'Doble click para editar',
              cellStyle: { cursor: 'text' },
              cellRendererSelector: ({value}) => {
                const status = cedis.find(x => x.id === value);
                return {
                  component: "AgBadge",
                  params: {
                    text: status.id,
                    color: status.color,
                  }
                };
              },
              editable: true,
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: cedis.map((x) => x.id),
              },
            },
            {
              headerName: "Turno",
              field: "turno",
              filter: "agSetColumnFilter",
              filterParams: {
                values: ({success}) => success(this.workShifts),
                defaultToNothingSelected: true,
                suppressSorting: true,
              },
              tooltipValueGetter: () => 'Doble click para editar',
              editable: true,
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: () => this.workShifts,
              },
            },
            {
              headerName: "Estatus",
              field: "active",
              filter: "agSetColumnFilter",
              editable: true,
              tooltipValueGetter: () => 'Doble click para editar',
              filterParams: {
                values: [true, false],
                suppressMiniFilter: true,
                defaultToNothingSelected: true,
                valueFormatter: (params) => {
                  return params.value ? "Activo" : "Inactivo";
                },
              },
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: [true, false],
                formatValue: (value) => value ? "Activo" : "Inactivo",
              },
              cellRendererSelector: ({value}) => {
                return {
                  component: "AgBadge",
                  params: {
                    text: value ? "Activo" : "Inactivo",
                    color: value ? "#34d399" : "#94a3b8",
                  }
                };
              },
            },

          ],
          defaultColDef: {
            suppressHeaderMenuButton: true,
            resizable: true,
            filter: true, 
            floatingFilter: true,
          },
          autoSizeStrategy: {
            type: 'fitGridWidth',
            defaultMinWidth: 100,
          },
          readOnlyEdit:true,
          stopEditingWhenCellsLoseFocus:true,
          pagination: true,
          paginationPageSize: 1000,
          paginationPageSizeSelector: [100, 500, 1000, 2000],
          loadingOverlayComponent: "BaseLoader",
          noRowsOverlayComponent: "EmptySection",
          rowSelection: "single",
          suppressCellFocus: true,
          enableCellTextSelection: true,
          alwaysShowVerticalScroll: true,
          localeText: AG_GRID_LOCALE_ES,
        },
      }
    },
    created() {
      const db = getFirestore();
        const coll = collection(db, "work_shifts");
        getDocs(coll).then((snapshot) => {
          this.workShifts = snapshot.docs.map((doc) => doc.data().name);
          this.getEmployees();
        });
    },
    methods: {
      getEmployees() {
        const db = getFirestore();
        const coll = collection(db, "employees")
        const qry = query(coll, orderBy("id", "asc"));

        getDocs(qry).then((snapshot) => {
          if (!snapshot.empty) {
            this.agEmployees.rowData = snapshot.docs.map((doc) => {
              return doc.data();
            });
          }
        });
      },
      onCellEditRequest({newValue, data, column}){
        if(newValue === undefined || newValue === null) return;
        this.$swal({
          title: `¿Editar empleado ${data.id} - ${data.name}?`,
          text : `El nuevo valor de ${column.colDef.headerName} será: ${newValue}`,
          icon: 'question',
          confirmButtonText: "Si, editar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            const db = getFirestore();
            const coll = collection(db, "employees");
            const docRef = doc(coll, data.id);
            setDoc(docRef, {[column.colId]: newValue}, { merge: true })
            .then(() => {
              this.getEmployees();
              this.$swal({
                title: "Empleado actualizado",
                text: `El empleado ${data.id} ha sido actualizado correctamente`,
                icon: "success",
              });
            }).catch((error) => {
              console.error("Error updating employee: ", error);
              this.$swal({
                title: "Error al actualizar empleado",
                text: `Ocurrió un error al actualizar el empleado ${data.id} - ${data.name}`,
                icon: "error",
              });
            });

          }
        });
      }
    },
  }
</script>

<style>
</style>